import closeCompose from '../actions/closeCompose';
import datapoints from '../datapoints';
import { uiLessAddinIsRunning } from '../utils/blockOnNavigation';
import { isViewStateDirty } from '../utils/viewStateUtils';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import endSession from 'owa-controls-findpeople-feedback-manager/lib/actions/endSession';
import deleteItemService from 'owa-mail-store/lib/services/deleteItemService';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
import { logSmartReplyDatapoint } from '../utils/logSmartReplyComposeDatapoint';
function deleteDraft(viewState) {
    if (viewState && viewState.itemId) {
        deleteItemService([viewState.itemId], 'MoveToDeletedItems');
    }
    endSession(viewState.findPeopleFeedbackManager, 'Discard');
    closeCompose(viewState);
}
export default action('discardCompose', datapoints.ComposeCommandDiscardCompose)(function discardCompose(viewState, doNotConfirm) {
    // No need to show confirm dialog when the viewState is not dirty and
    // (No draft created for this viewState, or draft is never saved since created),
    // Or there is no running uiless add-in
    var resolveImmediately = doNotConfirm ||
        (!isViewStateDirty(viewState) &&
            (!viewState.itemId ||
                (viewState.operation != 4 /* EditDraft */ &&
                    !viewState.lastSaveTimeStamp)) &&
            !uiLessAddinIsRunning(viewState));
    return confirm(strings.confirmDiscardText, strings.confirmDiscardSubText, resolveImmediately, {
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then(function (response) {
        if (response === DialogResponse.ok) {
            deleteDraft(viewState);
        }
        // If we are discarding a message created via smart reply, log a datapoint.
        logSmartReplyDatapoint(2 /* Discard */, viewState.smartReplyExtractionId);
    });
});
//# sourceMappingURL=discardCompose.js.map